import * as actionTypes from "./actionTypes";
import api from "./api";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import * as eventTypes from "./eventTypes";

export function loadDecisionSummary(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    let loading = false,
      loaded = false;
    const summary = getState().document.decision.summary[key];
    if (summary) {
      loading = summary.loading;
      loaded = summary.loaded;
    }

    if (loading || loaded) return;

    try {
      dispatch({ type: actionTypes.LOAD_DECISION_SUMMARY_STARTED, id: key });
      const decisionSummary = await dispatch(sendHttpRequest(api.loadDecisionSummary(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_DECISION_SUMMARY_SUCCESS, payload: decisionSummary, id: key });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadContractGenPermissions(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    let loading = false,
      loaded = false;
    let genPermissions = getState().document.decision.contractGenPermissions[key];
    if (genPermissions) {
      loading = genPermissions.loading;
      loaded = genPermissions.loaded;
    }

    if (loading || loaded) return;

    try {
      dispatch({ type: actionTypes.LOAD_CONTRACT_GEN_PERMISSIONS_STARTED, id: key });
      genPermissions = await dispatch(sendHttpRequest(api.loadContractGenPermissions(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_CONTRACT_GEN_PERMISSIONS_SUCCESS, payload: genPermissions, id: key });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function generateContract(documentId, siteId) {
  return async dispatch => {
    const key = `${documentId}-${siteId}`;
    dispatch({ type: actionTypes.CONTRACT_GENERATION_STARTED });
    try {
      const event = dispatch(
        sendHttpCommandAndWaitForEvent(api.generateContract(documentId, siteId), "GenerateContract", [
          eventTypes.CONTRACT_GENERATED
        ])
      );

      if (event.ok) {
        dispatch({ type: actionTypes.CONTRACT_GENERATION_SUCCEEDED, id: key });
      }

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
